export function isChromiumBrowser () {
    const isChromium = window.chrome;
    const windowNavigator = window.navigator;
    const vendorName = windowNavigator.vendor;
    const isOpera = typeof window.opr !== "undefined";
    const isEdge = windowNavigator.userAgent.indexOf("Edg") > -1;
    const isChromeOnIos = windowNavigator.userAgent.match("CriOS");

    if (
        (
            isChromium !== null
            &&
            typeof isChromium !== 'undefined'
            &&
            vendorName === 'Google Inc.'
            &&
            isOpera === false
        )
        ||
        isEdge === true
        ||
        isChromeOnIos === true
    ) {
        return true;
    } else {
        return false;
    }
}
